import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700 && window.scrollY < document.body.scrollHeight - 1400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <a href="#waitlist" className={`md:hidden fixed bottom-4 left-4 right-4 z-40 text-center px-6 py-3.5 bg-ink text-bone text-[11px] uppercase tracking-[0.32em] transition-all duration-500 ${show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6 pointer-events-none'}`} data-id="element-103">
      Join the Waitlist
    </a>;
}